<template>
    <div class="cc-doppelbindung">
        <ul>
            <li>sp<sup>2</sup>-Hybridisierung</li>
            <li>σ-Bindung + π-Bindung</li>
            <li>keine freie Drehbarkeit</li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'cc-doppelbindung',
};
</script>
